import { render, staticRenderFns } from "./SlcSaveSearchButton.vue?vue&type=template&id=02b8f0e8&scoped=true&"
import script from "./SlcSaveSearchButton.vue?vue&type=script&lang=ts&"
export * from "./SlcSaveSearchButton.vue?vue&type=script&lang=ts&"
import style0 from "./SlcSaveSearchButton.vue?vue&type=style&index=0&id=02b8f0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8f0e8",
  null
  
)

export default component.exports